import React from 'react'
import styled from 'styled-components'
import Button from 'react-bootstrap/Button'

const StyledButton = styled(Button)`
  @media (max-width: 576px) {
    width: 100% !important;
    display: block;
  }
`

const StyledAddRowButton = ({ children, ...rest }) => {
  return <StyledButton {...rest}>{children}</StyledButton>
}

export default StyledAddRowButton
